
import "../../Foundation/stylable/typography.st.css.js";
import "../../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_Affix";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_Affix__root","text-tiny-thin":"wds_1_109_2_StylableTypography__text-tiny-thin","text-small-normal":"wds_1_109_2_StylableTypography__text-small-normal","text-small-thin":"wds_1_109_2_StylableTypography__text-small-thin","text-medium-normal":"wds_1_109_2_StylableTypography__text-medium-normal","text-medium-thin":"wds_1_109_2_StylableTypography__text-medium-thin"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-input-value-font-line-height-tiny":"--wds-input-value-font-line-height-tiny","wds-input-value-font-line-height-small":"--wds-input-value-font-line-height-small","wds-input-value-font-line-height-medium":"--wds-input-value-font-line-height-medium","wds-input-value-font-line-height-large":"--wds-input-value-font-line-height-large","wds-input-value-font-size-tiny":"--wds-input-value-font-size-tiny","wds-input-value-font-size-small":"--wds-input-value-font-size-small","wds-input-value-font-size-medium":"--wds-input-value-font-size-medium","wds-input-value-font-size-large":"--wds-input-value-font-size-large","wds-color-text-standard-secondary-light":"--wds-color-text-standard-secondary-light","wds-color-text-placeholder":"--wds-color-text-placeholder","wds-color-text-disabled":"--wds-color-text-disabled","wds-space-50":"--wds-space-50","wds-space-100":"--wds-space-100"}; 




